
import React from 'react';
import { Tag } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Separator } from '@/components/ui/separator';

interface BlogTag {
  id: string;
  name: string;
}

interface BlogPostTagsProps {
  tags: BlogTag[];
  isNavigating: boolean;
  onTagClick: (tagName: string) => void;
}

export function BlogPostTags({ tags, isNavigating, onTagClick }: BlogPostTagsProps) {
  if (!tags || tags.length === 0) {
    return null;
  }
  
  return (
    <div className={`mt-8 ${isNavigating ? 'opacity-70' : ''}`}>
      <Separator className="mb-4" />
      <div className="flex items-center gap-2 flex-wrap">
        <Tag className="h-4 w-4 text-muted-foreground" />
        {tags.map((tag) => (
          <button 
            key={tag.id}
            onClick={() => onTagClick(tag.name)}
            className="inline-block"
          >
            <Badge variant="secondary" className="hover:bg-secondary">
              {tag.name}
            </Badge>
          </button>
        ))}
      </div>
    </div>
  );
}
